module.exports = __webpack_public_path__ + "../resources/img/pictogram_load.62fdfdc4.png";